import React,{useEffect} from 'react';
import useSharedDocHeader from "./DocHeaderHook";
import { noraWebTheme } from './noraWebTheme';
import createTheme from '@mui/material/styles/createTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import CategoryImageLink from './CategoryImageLink';
import { useLocation } from 'react-router-dom';
import {  useQuery } from 'react-query';

const catGrpQuery = (id) => ({
  queryKey: ['category_group',id],
  queryFn: async () => fetch('/data/CAT_GRP_' + id.toUpperCase() + '.json'
  ,{
    headers : { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }).then(res =>
    res.json()
  ),option:{staleTime:1000*60*5}
})

export const loader =
  (queryClient,id) =>
  async () => {
    const query = catGrpQuery(id);
    // ⬇️ return data or fetch it
    return (
      queryClient.getQueryData(query.queryKey) ??
      (await queryClient.fetchQuery(query))
    )
  }

export default function CategoryImageGrid(props) {
  const {doSetTitleKey,doSetMetaDescKey,doSetRouterId} = useSharedDocHeader();

  // get the selected CategoryGroup from the URL i.E. /Installations, /Pictures or /Objects
  let location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const newId = pathnames[0];

  const { isLoading, isSuccess,error, data } = useQuery(catGrpQuery(newId));
  
  useEffect(() => {
    doSetTitleKey("categoryLabel:CAT_GRP_"+ newId.toUpperCase());
    doSetRouterId('/' + newId);
  }, [newId]);

  if (isLoading){ 
    return 'Loading...';
  }

  if (error){ 
    return 'An error has occurred: ' + error.message;
  }

  const BREAKPOINTS = {
    xs: 0,
    sm: 610,
    md: 920,
    lg: 1230,
    xl: 1540,
  };
  const breakpointsValues = {
    breakpoints: {
      values: BREAKPOINTS
    }
  };
  const gridTheme = createTheme({ ...noraWebTheme, ...breakpointsValues });

  const ContainerStyling = {
      backgroundColor: 'background.paper',
      flexGrow:1,
  }

  const outer = {
    border: '0',
    margin:'0',
    mt:{ xs: 6, md: 12 },
    color:'black',
    fontSize: '25px' ,
    textAlign: 'center',
    alignItems:'top',
    fontWeight: 'bold',
    flexGrow :1,
    bgcolor: 'background.paper',
    height:'100vh',
  };

  if (isSuccess){
    doSetMetaDescKey("categoryMetaDesc:" + data.meta_desc_key);
    return (
      <Grid2 display="flex" flexDirection="column" sx={outer}>
        <ThemeProvider theme={gridTheme}>
          <Grid2 container rowSpacing={0} sx={ContainerStyling}>
              {data.children.map((item, index) => (
                  <Grid2 key={item.id} sx={{bgcolor: 'background.paper',}} display='flex' alignItems='center' justifyContent='center' xs={12} sm={6} md={4} lg={3}>
                      <CategoryImageLink id={item.id} labelKey={item.labelKey} tnUrl={item.tnUrl} tnWidth={item.tnWidth} tnHeight={item.tnHeight} parentUrl={newId}/>
                  </Grid2>
              ))}
          </Grid2>
        </ThemeProvider>
    </Grid2>
    )
  }
}